import { ComponentSingleStyleConfig, useStyleConfig } from "@chakra-ui/react";
import React from "react";
import { ComponentStyleProps } from "../../../../../lib/styles/props/component-style-props";
import { CMItemEditRequest } from "../CMItemEditRequest/CMItemEditRequest";

export type CMFormCommentMainProps = {
  /**
   * 編集ボタンのラベル・Ariaラベル。
   * 編集可能な場合、設定を強く推奨する。
   */
  editButtonLabel?: string;
  /**
   * テキストエリアの最大文字数。
   * 指定しなければ無制限。
   */
  maxLength?: number;

  /**
   * 編集モードの表示項目に使用。
   */
  commentInput: {
    placeholder?: string;
    finishButtonLabel: string;
    cancelButtonLabel: string;
    deleteButtonLabel: string;
  };

  /**
   * 削除確認時の表示項目に使用する。
   */
  deleteConfirmationModal: {
    title: string;
    message?: string;
    deleteButtonLabel: string;
    cancelButtonLabel: string;
  };

  /**
   * 削除確認モーダルの制御に使用する。
   */
  deleteConfirmationModalSettings: {
    isOpen: boolean;
    onOpen: () => void;
    onClose: () => void;
  };

  /**
   * 表示項目に使用。
   */
  content?: {
    userName: string;
    date: Date;
    comment: string;
  };

  /**
   * 編集開始または編集することが可能である。
   */
  editable: boolean;
  /**
   * 保存して編集終了したときのコールバック。
   * nullに更新する場合、削除を表す。
   */
  onSave?: (value: string | null) => void;
} & ComponentStyleProps;

/**
 * 修正依頼コメントリストアイテムを表示するコンポーネント
 */
export const CMFormCommentMain = ({
  editButtonLabel,
  maxLength,

  commentInput,

  deleteConfirmationModal,
  deleteConfirmationModalSettings,

  content,

  editable,
  onSave,

  sx,
  ...rest
}: CMFormCommentMainProps) => {
  const styles = useStyleConfig("CMFormCommentMainStyles");
  return (
    <CMItemEditRequest
      editButtonLabel={editButtonLabel}
      maxLength={maxLength}
      commentInput={commentInput}
      deleteConfirmationModal={deleteConfirmationModal}
      deleteConfirmationModalSettings={deleteConfirmationModalSettings}
      content={content}
      editable={editable}
      onSave={onSave}
      sx={{ ...styles, ...sx }}
      {...rest}
    />
  );
};

export const CMFormCommentMainStyles: ComponentSingleStyleConfig = {
  baseStyle: {},
};
